import { render, staticRenderFns } from "./order-deliveries-buttons.vue?vue&type=template&id=52dc2f3d&"
import script from "./order-deliveries-buttons.vue?vue&type=script&lang=js&"
export * from "./order-deliveries-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports